import {
  useGetSubscriptionPermissionQuery,
  useGetSubscriptionsQuery,
} from "store/apis/subscriptions";
import { useCurrentEntityId } from "./useCurrentEntityId";
import { useCurrentGroupContext } from "./useCurrentGroupContext";
import { entitiesSortedByCountry } from "utils/entitiesSortedByCountry";

export const useHasSubscriptionPermission = ({
  feature,
  route,
  product_type = "BOOKS",
  parentEntityId,
}: {
  feature?: string;
  route?: string;
  product_type?: "TAX" | "BOOKS";
  parentEntityId?: string;
}) => {
  const { uuid: groupId } = useCurrentGroupContext();
  const { entities } = useCurrentGroupContext();
  const { usEntities } = entitiesSortedByCountry(entities);
  const existingEntity = useCurrentEntityId();
  const entityId = parentEntityId || existingEntity || usEntities?.[0]?.uuid;
  const { data: permissions, isSuccess } = useGetSubscriptionPermissionQuery(
    {
      entityId,
      product_type,
    },
    {
      skip: !entityId,
    }
  );

  const { data: subscriptions } = useGetSubscriptionsQuery(
    {
      groupId: groupId,
    },
    { skip: !groupId }
  );

  if (feature) {
    const message = permissions?.feature_map?.[feature]?.message;

    const permission = permissions?.feature_map?.[feature];
    return {
      ...permission,
      message,
      isLoading: !isSuccess,
      subscription: subscriptions?.find(
        (sub) => sub.uuid === permission?.subscription_required.uuid
      ),
    };
  }

  if (route) {
    const permission = permissions?.route_map?.[route];
    return {
      ...permission,
      isLoading: !isSuccess,

      subscription: subscriptions?.find(
        (sub) => sub.uuid === permission?.subscription_required.uuid
      ),
    };
  }

  return null;
};
